import React, { Component } from 'react'
import reactCSS from 'reactcss'
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
export default class AlignmentPicker extends Component {
    constructor(props){
        super(props);
        this.state ={
            displayAlignmentPicker: false,
            align:'left',
        }
    }
    handleClick = () => {
        this.setState({ displayAlignmentPicker: !this.state.displayAlignmentPicker })
      };
    
      handleClose = () => {
        this.setState({ displayAlignmentPicker: false })
      };
    
      handleChange = (value) => {
        console.log(value)
       this.props.handleChangeAlignment(value);
      };
  render() {
    const styles = reactCSS({
        'default': {
          color: {
            width: '30px',
            height: '5px',
            borderRadius: '2px',
            // background: `rgba(${ this.state.color.r }, ${ this.state.color.g }, ${ this.state.color.b }, ${ this.state.color.a })`,
          },
          swatch: {
            padding: '1px',
            background: '#fff',
            borderRadius: '1px',
            // boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
            display: 'inline-block',
            cursor: 'pointer',
            textAlign:'center',
            fontSize:'20px',
            border:'none'
          },
          popover: {
            marginTop:'5px',
            position: 'absolute',
            zIndex: '2',
            backgroundColor:'whitesmoke',
            minWidth:'120px',
            padding:'5px 5px 3px 5px',
            boxShadow:'2px 2px 15px rgb(0 0 0 / 10%)'
          },

          cover: {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
            zIndex:-1
          },
        },
      });

      return (
        <div>
          <div style={ styles.swatch } onClick={ this.handleClick }>
            {
                this.props.align === 'left' && <FormatAlignLeftIcon style={{fontSize:'19px'}}/>
            }
             {
                this.props.align === 'center' && <FormatAlignCenterIcon style={{fontSize:'19px'}}/>
            }
             {
                this.props.align === 'right' && <FormatAlignRightIcon style={{fontSize:'19px'}}/>
            }
           
          </div>
          { this.state.displayAlignmentPicker ? <div style={ styles.popover }>
            <div style={ styles.cover } onClick={ this.handleClose }/>
            <ul className="alignment-item">
                                        <li className={this.props.align === 'left' ? 'active' : ''}  onClick={()=>this.handleChange('left')}><FormatAlignLeftIcon/></li>
                                        <li className={this.props.align === 'center' ? 'active' : ''} onClick={()=>this.handleChange('center')}><FormatAlignCenterIcon /></li>
                                        <li className={this.props.align === 'right' ? 'active' : ''} onClick={()=>this.handleChange('right')}><FormatAlignRightIcon /></li>
                                    </ul>
          </div> : null }
  
        </div>
      )
    }
  
}
